<template>
  <div class="user-detail-box">
    <header class="header">
      <span class="font" @click="back"><span class="el-icon-arrow-left icon"></span>返回</span>
      <span class="shu">|</span>
      <span class="font-text">{{ $route.query.name }}</span>
    </header>

    <section class="main-content">
      <div class="content-copy">
        <el-row>
          <el-col :span="16">
            <div class="content-box-copy" style="padding-top: 10px">
              <div class="title">产品管理</div>
              <div class="sub-title">
                共{{ sum }}个产品&nbsp;&nbsp;<span class="higlight">企业产品:{{ company }},已过期产品:{{ expired }}</span>
              </div>
              <el-table :data="users" highlight-current-row v-loading="listLoading"
                style="width: 100%; margin-top: 10px; height: auto">
                <el-table-column type="index" label="序号" width="80">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="productname" label="名称" min-width="220" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="typename" label="类型" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="usingstatusname" label="状态" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span style="color: #2196f3" v-if="scope.row.usingstatus == 1">{{ scope.row.usingstatusname }}</span>
                    <span v-else>{{ scope.row.usingstatusname }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="duetime" label="到期时间">
                  <template slot-scope="scope">
                    {{ scope.row.duetime.split(" ")[0] }}
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="80" style="text-algin: center">
                  <template slot-scope="scope">
                    <span class="operate">
                      <el-tooltip effect="dark" content="禁用" placement="top" v-if="scope.row.usingstatus == 1">
                        <span class="dnnfont icondisabled" @click="handleDel(scope.$index, scope.row)"></span>
                      </el-tooltip>

                      <el-tooltip effect="dark" content="启用" placement="top" v-if="scope.row.usingstatus == 3">
                        <span class="dnnfont iconaccomplish" @click="handleOpen(scope.$index, scope.row)"></span>
                      </el-tooltip>
                    </span>
                    <!-- <el-button type="danger" v-if="scope.row.usingstatus == 1"  plain size="small" @click="handleDel(scope.$index, scope.row)">禁用</el-button>
              <el-button type="primary" v-if="scope.row.usingstatus == 3"  plain size="small" @click="handleOpen(scope.$index, scope.row)">启用</el-button> -->
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="content-box-two-copy" style="padding-top: 10px">
              <div class="title">登录日历</div>
              <Calendar> </Calendar>
            </div>
          </el-col>
        </el-row>
      </div>

      <div class="content-copy">
        <el-row>
          <el-col :span="16">
            <div class="content-box-copy">
              <LeftCharts :userid="$route.query.userId" />
            </div>
          </el-col>
          <el-col :span="8">
            <div class="content-box-two-copy">
              <RightCharts :userid="$route.query.userId" />
            </div>
          </el-col>
        </el-row>
      </div>
      <div :class="showRecords ? 'content-copy' : 'newstyle'">
        <el-row>
          <el-col :span="showRecords ? 16 : 24">
            <div :class="showRecords ? 'newstyle' : ''">
              <div class="title">客户备注</div>
              <div>
                <el-input v-model="textarea" :rows="3" type="textarea" placeholder="填写留言"
                  style="margin-top: 10px"></el-input>
                <el-button type="primary" size="medium" style="margin-top: 10px" @click="addUserNote">提交</el-button>
              </div>
              <div style="margin-top: 10px; color: #616161; margin-bottom: 10px">
                所有备注({{ allcount }})
              </div>
              <div class="contextx" v-for="(item, index) in notes" :key="index">
                <div class="contexss" style="height: 30px">
                  <span style="
                          display: block;
                          width: 80px;
                          float: left;
                          font-weight: bold;
                        ">{{ item.userName }}</span>
                  <span style="
                          display: block;
                          margin-left: 20px;
                          float: left;
                          color: #acabab;
                        ">{{ item.intime }}</span>
                </div>
                <div style="clear: both"></div>
                <div class="contexss" style="color: #707070">
                  {{ item.note }}
                </div>
              </div>
              <hr style="border-top: 0.5px solid #d4d3d3" />
            </div>
          </el-col>

          <el-col :span="8" v-if="showRecords">
            <div class="content-box-two-copy" v-loading="loginInfoLoading">
              <div class="record_title">登录记录统计</div>
              <div class="login_info">
                <span class="login_title">总计登录：<span class="login_num">{{ countNum }}次</span></span>
              </div>
              <div class="last_time">
                您上次登陆时间和位置：{{ lastLogin_time }}，{{
                  lastLogin_location
                }}
              </div>
              <div class="history">历史记录（最近10次）</div>
              <div class="history_item" v-for="item in infos">
                <span class="date">{{ item.date }}</span>
                <span class="times">{{ item.times }}</span>
                <span class="ip">{{ item.ip }}</span>
                <span class="location">{{ item.location }}</span>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </section>
  </div>
</template>

<script>
import { API__code, API_Admin, API_Auth, API_Man } from "../../../api/index.js";
import LeftCharts from "./charts";
import RightCharts from "./rightCharts";
import Calendar from "./calender";
export default {
  data() {
    return {
      textarea: "",
      listLoading: false,
      loginInfoLoading:false,
      notes: [],
      allcount: 0,
      token: "",
      checkCode: "",
      id: "",
      // ip: returnCitySN["cip"],
      users: [],

      expired: 0,
      company: 0,

      sum: 0,
      showRecords: true,

      lastLogin_time: 0,
      lastLogin_location: "",
      infos: [],
      countNum: 0,
      phone:""
    };
  },
  created() {
    this.getCookie();
    this.getUserNote();
  },
  methods: {
    back() {
      if (this.$route.query.shengfeng) {
        this.$router.push({
          path: "/activityWarn",
          query: {
            datanum: this.$route.query.datanum,
            zhanghao: this.$route.query.zhanghao,
            accountManager: this.$route.query.accountManager,
            pageNumber: this.$route.query.pageNumber,
            pageSize: this.$route.query.pageSize,
          },
        });
      } else if (this.$route.query.jiangshi) {
        this.$router.push({
          path: "/dailyStatistics",
          query: {
            managerAdminuser: this.$route.query.managerAdminuser,
            pageNumber: this.$route.query.pageNumber,
            pageSize: this.$route.query.pageSize,
            jiangshi: 1,
          },
        });
      } else {
        this.$router.push({
          path: "/account",
          query: {
            dynamicTags: this.$route.query.dynamicTags,
            souchs: this.$route.query.souchs,
            type: 1,
            pageNumber: this.$route.query.pageNumber,
            pageSize: this.$route.query.pageSize,
            searchName: this.$route.query.searchName,
            isCompanyUser: this.$route.query.isCompanyUser,
            fromtime: this.$route.query.fromtime,
            totime: this.$route.query.totime,
            managerAdminuser: this.$route.query.managerAdminuser,
            distributionStatus: this.$route.query.distributionStatus,
          },
        });
      }
    },
    getData() {
      var param = {
        token: this.token,
        checkCode: this.checkCode,
        pageNumber: 1,
        pageSize: 999,
        listType: "paged",
        userid: this.$route.query.userId,
      };
      this.listLoading = true;
      API_Admin.getList(param)
        .then((res) => {
          if (res.data.code == 200) {
            this.users = res.data.data;
            this.sum = res.data.data.length;
            this.expired = res.data.expired;
            this.company = res.data.company;
          }
          this.listLoading = false;
        })
        .catch((e) => {
          this.listLoading = false;
        });
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        // console.log({ arr });
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "dnnyptadmin_token") {
            this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "dnnyptadmin_checkCode") {
            this.checkCode = arr2[1];
          } else if (arr2[0] == "dnnyptadmin_id") {
            this.id = arr2[1];
          } 
          if (arr2[0] == "dnnyptadmin_token") {
            this.phone = arr2[1];
          }
        }
      }
      this.getData();

      if (this.$route.query.notShowRecords) {
        this.showRecords=false
        return
      }
      this.getLoginInfor();

    },
    handleDel: function (index, row) {
      this.$confirm("确认禁用吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          var ids;
          ids = row.id;
          let param = {
            token: this.token,
            checkCode: this.checkCode,
            ids: ids,
            usingstatus: 3,
          };
          API_Auth.delAutoList(param)
            .then((res) => {
              if (res.data.code == API__code.SUCCESS) {
                this.$message({
                  message: "禁用成功",
                  type: "success",
                });
                this.getData();
              }
            })
            .catch((err) => {
              this.$message.error("数据丢失，试试重新登陆！");
            });
        })
        .catch(() => { });
    },
    handleOpen: function (index, row) {
      let _this = this;
      this.$confirm("确认启用吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          var ids;
          ids = row.id;
          let param = {
            token: this.token,
            checkCode: this.checkCode,
            ids: ids,
            usingstatus: 1,
          };
          API_Auth.delAutoList(param)
            .then((res) => {
              if (res.data.code == API__code.SUCCESS) {
                this.$message({
                  message: "启用成功",
                  type: "success",
                });
                this.getData();
              }
            })
            .catch((err) => {
              this.$message.error("数据丢失，试试重新登陆！");
            });
        })
        .catch(() => { });
    },
    //用户新增留言
    addUserNote() {
      if (this.textarea == "") {
        this.$message.error("数据不能为空");
      } else {
        let params = {
          token: this.token,
          checkCode: this.checkCode,
          note: this.textarea,
          userId: this.$route.query.userId,
        };
        API_Auth.addUserNote(params).then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: "提交成功",
              type: "success",
            });
            this.textarea = "";
            this.getUserNote();
          }
        });
      }
    },
    //获取客户留言信息
    getUserNote() {
      let params = {
        token: this.token,
        checkCode: this.checkCode,
        userId: this.$route.query.userId,
      };
      API_Auth.getUserNote(params).then((res) => {
        if (res.data.code == 200) {
          this.notes = res.data.data;
          this.allcount = res.data.data.length;
        }
      });
    },
    getLoginInfor: function () {
      this.loginInfoLoading=true
      let _this = this;
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        userid: this.$route.query.userId,
        // clientip: "127.0.0.1",
      };
      API_Man.getLoginInfor(param)
        .then((res) => {
          if (res.data.code == API__code.SUCCESS) {
            var arr = [];
            for (var i = 0; i < res.data.data.loginInfor.length; i++) {
              if (res.data.data.loginInfor[i].time) {
                res.data.data.loginInfor[i].date = res.data.data.loginInfor[
                  i
                ].time.substring(5, 10);
                res.data.data.loginInfor[i].date =
                  res.data.data.loginInfor[i].date.replace(/-/g, "月") + "日";
                res.data.data.loginInfor[i].times = res.data.data.loginInfor[
                  i
                ].time.substring(11, 16);
              }
              if (arr.length > 0) {
                for (var k = 0; k < arr.length; k++) {
                  if (res.data.data.loginInfor[i].date == arr[k]) {
                    res.data.data.loginInfor[i].date = "";
                  }
                }
              }
              arr.push(res.data.data.loginInfor[i].date);
            }
            if (res.data.data.loginInfor.length > 0) {
              _this.lastLogin_time = res.data.data.loginInfor[0].time;
              _this.lastLogin_location = res.data.data.loginInfor[0].location;
            }
            _this.infos = res.data.data.loginInfor;
            _this.countNum = res.data.data.loginCount;
          }
          this.loginInfoLoading=false
        })
        .catch((err) => {
          this.loginInfoLoading=false
          this.$message.error("数据丢失，试试重新登陆！");
        });
    },
  },
  components: {
    LeftCharts,
    RightCharts,
    Calendar,
  },
};
</script>

<style lang="scss" scoped>
.user-detail-box {
  width: 100%;
  height: 100%;

  .main-content {
    height: calc(100% - 80px);
    min-width: 1400px;
    box-sizing: border-box;
    overflow: auto;
  }
}

.header {
  height: 64px;
  line-height: 64px;
  margin-bottom: 15px;
  background: #ffffff !important;
  padding: 0px 20px;
  box-sizing: border-box;

  .font {
    color: #596471;
    font-size: 16px;
    position: relative;
    top: -2px;
    margin-left: 10px;
    cursor: pointer;
  }

  .font-text {
    color: #596471;
    font-size: 16px;
    position: relative;
    top: -2px;
    margin-left: 10px;
  }

  .font:hover {
    color: #4091ff;
  }

  .shu {
    height: 50px;
    font-size: 27px;
    border-left: 1px solid #e8e9eb;
    margin-left: 15px;
  }

  .icon {
    margin-right: 5px;
  }
}

.content-copy {
  width: 100%;
  box-sizing: border-box;
  padding: 0px 21px 0px 0px;
  margin-bottom: 15px;
  height: 430px;

  &:last-child {
    margin-bottom: 0;
  }

  .sub-title {
    font-family: SourceHanSansCN;
    font-size: 14px;
    color: #596471;
    margin-top: 20px;

    .higlight {
      color: #f44336;
    }
  }
}

.title {
  font-family: SourceHanSansCN;
  font-size: 19px;
  color: #596471;
  margin-top: 10px;
}

.content-box-copy {
  width: 100%;
  height: 430px;
  background-color: white;
  border-radius: 2px;
  padding: 32px 28px;
  box-sizing: border-box;
  overflow: auto;
}

.content-box-two-copy {
  background-color: white;
  border-radius: 2px;
  width: 100%;
  height: 430px;
  margin-left: 20px;
  padding: 32px 28px;
  box-sizing: border-box;

  .record_title {
    font-weight: 500;
    font-size: 16px;
    color: #596471;
    margin-bottom: 15px;
  }

  .login_info {
    margin-bottom: 10px;
  }

  .login_title {
    font-weight: 500;
    font-size: 14px;
    color: #333333;
  }

  .login_num {
    font-weight: 700;
    font-size: 18px;
    color: #f66b3d;
  }

  .last_time {
    font-weight: 500;
    font-size: 14px;
    color: #f66b3d;
    margin-bottom: 10px;
  }

  .history {
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    margin-bottom: 15px;

  }

  .history_item {
    height: 25px;
    display: flex;

    .date {
      font-size: 14px;
      color: #333;
      flex: 1;
      font-weight: bold;
    }

    .times {
      font-size: 12px;
      color: #666;
      flex: 1;
      padding-top: 3px;
    }

    .ip {
      font-size: 12px;
      color: #666;
      flex: 1;
      padding-top: 3px;
    }

    .location {
      font-size: 12px;
      color: #666;
      flex: 1;
    }
  }
}

.newstyle {
  width: 100%;
  // height: 600px;
  height: 430px;
  background-color: white;
  border-radius: 2px;
  padding: 32px 28px;
  box-sizing: border-box;
  overflow: auto;
}

.contextx {
  padding: 16px 0px;
  border-top: 1px solid #d4d3d3;

  // border-bottom: 1px solid #d4d3d3;
  .contexss {
    // line-height: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// userDetail.vue?47fe79b0